/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/awardFinder/resources/js/homePage/searchFormValidator.js
*    TO   --> ./webapps/homepage-web/src/main/assets/js/home/award-finder/search-form-validator.js
**/

// filter utility used on search results page

var SearchFormValidator = {};
	
/**
 * This class has very little functionality, but simply
 * initializes the scValidator plugin. See init function
 */
SearchFormValidator = (function() {

	/**
	 * Initializing Validator for Car Details page
	 * 
	 */
	function initialize() {

		$('#searchRequestForm').aaValidator({
			trim: true,
			onSuccess: SearchUtil.submitSearchRequestForm,
			validateOnEvent: 'submit',
			validateEventObj: $('#searchRequestForm'),
			fields: {
				'origin': {
					required: true,
					len: 3,
					custom_airportValid: customValidators.airportValid
				},
				'departureMinDate': {
					required: true,
					custom_date: customValidators.dateValid,
					custom_dateNotPast: customValidators.dateNotPast,
					custom_dateNotTooFuture: customValidators.dateNotTooFuture
				},
                'returnMinDate': {
                	validatePrecondition: function() {
                		return $('#roundTrip option:selected').val() == 'true';
                	},
                	required: true,
					custom_date: customValidators.dateValid,
					custom_sequential: customValidators.dateOrder,
					custom_dateNotPast: customValidators.dateNotPast,
					custom_dateNotTooFuture: customValidators.dateNotTooFuture
				},
				'miles': {
					matches: "0-9,. "
				}
    		}
		});
		
	}
	var customValidators = {
		emailMatch: function(str) {
			return str.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/); // one or more non-whitespace '@' one or more non-whitespace '.' one or more non-whitespace
		},
		dateValid: function(str) {
			try {
				$.datepicker.parseDate(AAcom.prototype.getProperty('dateFormat'), str);
			} catch(error) {
				return false;
			}
			return true;
		},
		dateOrder: function(str) {
			try {
				var depart = $.datepicker.parseDate(AAcom.prototype.getProperty('dateFormat'), $('#departOnInput').val());
				var ret = $.datepicker.parseDate(AAcom.prototype.getProperty('dateFormat'), $('#returnOnInput').val());
				if(depart > ret){
					return false;
				}
			} catch(error) {}
			return true;
		},
		dateNotPast: function(str) {
			try {
				var d = $.datepicker.parseDate(AAcom.prototype.getProperty('dateFormat'), str);
				return d >= getToday();
			} catch(error) {} // pass if invalid date
			return true;
		},
		dateNotTooFuture: function(str) {
			try {
				var d = $.datepicker.parseDate(AAcom.prototype.getProperty('dateFormat'), str);
				return d < new Date().setDate(getToday().getDate()+331);
			} catch(error) {} // pass if invalid date
			return true;
		},
		airportValid: function(code) {
			if(SmartSuggestUtil.isDomUpToDateWithValidatedAirportCode(code)) {
				return SmartSuggestUtil.isValidFromDom(code);
			}
			else {
				return SmartSuggestUtil.isValidAjaxSynchronous(code);
			}
		}
	};
	
	function getToday() {
		var date = new Date();
		return new Date(date.getFullYear(), date.getMonth(), date.getDate(),0,0,0,0);
	}
	
	/**
	 * public functions
	 */
	return {
		initialize: initialize
	};
	
	
}());
	
